module.exports = __webpack_public_path__ + "media/images/icon__facebook-9eed200e2a5fb005bd05403b5e74d4a7.png";